import useSWR from 'swr';

import { fetchFromOldApi } from '~/services/Http';

export enum HRResponsibleRoles {
  HR_ADMIN = 'HR_ADMIN',
  HR_STAFF = 'HR_STAFF',
  HR_DEV = 'HR_DEV',
  HR_SALARY = 'HR_SALARY',
  HR_ADMIN_LIMITED = 'HR_ADMIN_LIMITED',
  HR_AUDITOR = 'HR_AUDITOR',
  HR_PEOP = 'HR_PEOP',
  HR_PEOP_DEV = 'HR_PEOP_DEV',
}

export type HRResponsibleWithRole = {
  role: HRResponsibleRoles;
  ids: number[];
};

const fetchRolesWithIds = async (): Promise<HRResponsibleWithRole[]> => {
  const roles = await Promise.all(
    Object.values(HRResponsibleRoles).map(async (role) => {
      const ids = await fetchFromOldApi(`/json/user/role/${role}`).then((r) =>
        r.json(),
      );
      return { role, ids };
    }),
  );
  return roles;
};

export const useHRResponsibleRolesWithIds = () => {
  const { data, error } = useSWR('rolesWithIds', fetchRolesWithIds);
  return {
    rolesWithIds: data,
    isLoading: !error && !data,
    isError: error,
  };
};
